/**
 * The dashboard's one card surface. Shared so the list, the skeleton and the
 * empty states cannot drift to different corners or elevations.
 */
export const DASHBOARD_CARD_CLASS =
  "rounded-xl border border-border bg-surface shadow-sm";
